import React, { useState } from "react";
import { getValidationProps } from "../../utils/formValidation";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";

export default function MojoSection({ data }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";

  const [formData, setFormData] = useState({
    email: "",
    name: "",
    source_url: sourceUrl,
    current_url: currentUrl,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      const onlyLetters = /^[A-Za-z\s]*$/;
      if (!onlyLetters.test(value)) {
        return;
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can contain only letters and spaces";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(formData.email.trim())) {
        newErrors.email = "Please enter a valid email";
      }
    }


    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/newsletter/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      if (result.error === false) {
        navigate("/thank-you");
      } else {
        toast.error(result.message || "Failed to subscribe.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <section className="energy-mgmt-section padding-top bg-gray">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="enthusiasm-content">
              <h3 className="heading text-center mb-5">{data.sectionTitle}</h3>
            </div>
          </div>
          <div className="col-lg-6 wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="2s"  >
            <img src={data.image} alt={data.imageAlt} className="img-responsive" />
          </div>
          <div className="col-lg-6 wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="2s"  >
            <span className="main-title">{data.eyebrow}</span>
            <h2 className="heading">{data.title}</h2>
            <strong>{data.lead}</strong>
            {data.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            <form onSubmit={handleSubmit}>
              <div className="form-wrapper">
                <div className="form-group">
                  <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} placeholder="Enter Name*" />
                  {errors.name && (<span className="validation-error"> {errors.name} </span>)}
                </div>
                <div className="form-group">
                  <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} placeholder="Enter Email Address*" />
                  {errors.email && (<span className="validation-error"> {errors.email} </span>)}
                </div>
              </div>
              <button type="submit" disabled={loading} className="default-btn">   {loading ? "Submitting..." : "Send Me Some Mojo"} </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
